import API from '@/api/index';

const dashboard = {
  actions: {
    getStatistics ({ state }) {
      return new Promise((resolve, reject) => {
        API.dashboard
          .getStatistics()
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              resolve(result.data);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getNewVehicles ({ state }, params) {
      return new Promise((resolve, reject) => {
        API.dashboard
          .getNewVehicles(params)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let vehicles = result.data;
              resolve(vehicles);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getNewAccounts ({ state }, params) {
      return new Promise((resolve, reject) => {
        API.dashboard
          .getNewAccounts(params)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let accounts = result.data;
              resolve(accounts);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  }
};

export default dashboard;



// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js